import React from "react";
import ReactExport from "react-export-excel";
import { Button } from "antd";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const Excelldownload = ({ data }) => {
  const exportData = data || [];
  return (
    <ExcelFile element={<Button type="primary" style={{backgroundColor:"green", color:"white", marginBottom: "10px", float: "right", marginRight: "10px" }}>Excel data</Button>}>
      <ExcelSheet data={exportData} name="Brands">
        <ExcelColumn label="SL" value={(row) => exportData.indexOf(row) + 1} />
        <ExcelColumn label="Name" value="name" />
        <ExcelColumn label="Slug" value="slug" />
      </ExcelSheet>
    </ExcelFile>
  );
};

export default Excelldownload;
